import {
  ArrowLeftMd,
  ArrowRightMd,
  DocumentLg,
  DocumentMd,
  DownloadMd,
  ExternalLinkMd,
  HomeHandLg,
  HomeMd,
  HomeMoneyMd,
  LinkLg,
  LinkMd,
  ListMd,
  MapMd,
  PencilMd,
  PhoneLg,
  ReportsMd,
} from '@property.com.au/ui-kit';
import { ButtonIconName, LinkIconName } from '../components/types';

export const mapIconName = (name: LinkIconName | ButtonIconName | undefined | null) => {
  switch (name) {
    case 'PhoneLg':
      return <PhoneLg data-testid="phone-icon-test-id" />;
    case 'ReportsMd':
      return <ReportsMd data-testid="reports-md-test-id" />;
    case 'ExternalLinkMd':
      return <ExternalLinkMd data-testid="external-link-icon-test-id" />;
    case 'LinkLg':
      return <LinkLg data-testid="link-lg-icon-test-id" />;
    case 'DocumentLg':
      return <DocumentLg data-testid="document-lg-icon-test-id" />;
    case 'LinkMd':
      return <LinkMd data-testid="link-md-icon-test-id" />;
    case 'DocumentMd':
      return <DocumentMd data-testid="document-md-icon-test-id" />;
    case 'DownloadMd':
      return <DownloadMd data-testid="download-md-icon-test-id" />;
    case 'ArrowLeftMd':
      return <ArrowLeftMd data-testid="arrow-left-md-test-id" />;
    case 'ArrowRightMd':
      return <ArrowRightMd data-testid="arrow-right-md-test-id" />;
    case 'MapMd':
      return <MapMd data-testid="map-md-test-id" />;
    case 'ListMd':
      return <ListMd data-testid="list-md-test-id" />;
    case 'PencilMd':
      return <PencilMd data-testid="pencil-md-test-id" />;
    case 'HomeMoneyMd':
      return <HomeMoneyMd data-testid="home-money-md-test-id" />;
    case 'HomeMd':
      return <HomeMd data-testid="home-md-test-id" />;
    case 'HomeHandLg':
      return <HomeHandLg data-testid="home-hand-lg-test-id" />;
    default:
      return null;
  }
};
